// components/PatentGallery.tsx
// Server Component - no "use client" needed!

interface PatentGalleryProps {
  patentId: string;
}

export async function PatentGallery({ patentId }: PatentGalleryProps) {
  // Fetch at build time (server-side)
  let pages: any[] = [];
  
  try {
    const response = await fetch('https://thedailydialectics.com/api/registry/directory/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ directory: `/pdfs/wipow/patents/${patentId}` }),
      cache: 'force-cache'  // Cache for static generation
    });
    
    if (response.ok) {
      const data = await response.json();
      pages = data.result || [];
    }
  } catch (error) {
    console.error('Failed to fetch patent gallery:', error);
  }
  
  if (pages.length === 0) {
    return <div className="patent-gallery-empty">No pages found</div>;
  }
  
  return (
    <div className="patent-gallery">
      {pages.map((page: any, i: number) => (
        <img 
          key={i}
          src={page.image_url}
          alt={page.title || `Page ${i + 1}`}
          title={page.title || `Page ${i + 1}`}
          loading="lazy"
        />
      ))}
    </div>
  );
}
